<script lang="ts" setup>
withDefaults(
  defineProps<{
    dark?: boolean
    size?: 'sm' | 'lg'
    window?: boolean
    purple?: boolean
  }>(),
  {
    dark: false,
    size: 'sm',
    window: true,
    purple: false,
  },
)
</script>

<template>
  <div
    class="flex items-center overflow-hidden rounded-t-lg"
    :class="{
      'bg-gray-900': dark,
      'bg-purple-700 text-white': purple,
      'border-b border-gray-100 bg-gray-50': !dark && !purple,
      'h-[24px] gap-[20px] px-[8px] text-[8px] leading-[16px]': size === 'sm',
      'h-[40px] gap-[32px] px-[16px] text-[12px] leading-[24px]': size === 'lg',
    }"
  >
    <div v-if="window" class="flex" :class="{ 'gap-[6px]': size === 'sm', 'gap-[8px]': size === 'lg' }">
      <div
        v-for="n in 3"
        :key="n"
        class="rounded-full border"
        :class="{
          'border-gray-1000 bg-gray-800': dark,
          'border-purple-500': purple,
          'border-gray-200': !dark && !purple,
          'h-[12px] w-[12px]': size === 'lg',
          'h-[8px] w-[8px]': size === 'sm',
        }"
      />
    </div>
    <slot />
  </div>
</template>
